<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg)"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Edit Ingredient</h1>
      </b-row>
    </base-header>
    <b-container class="container--md mt--6">
      <div class="add-recipe__container">
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form
            class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)"
          >
            <div class="form-row">
              <b-col md="12">
                <base-input
                  label="Ingredient Name"
                  name="title"
                  type="textarea"
                  placeholder="Ingredient Name"
                  success-message=""
                  rules="required"
                  v-model="model.description"
                >
                </base-input>
              </b-col>
            </div>
            <base-button type="primary" native-type="submit"
              >Save Ingredient</base-button
            >
            <base-button
              type="secondary"
              native-type="button"
              @click="$router.go(-1)"
              >Cancel</base-button
            >
          </form>
        </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
//import { Select, Option } from 'element-ui'
//import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
//import IngredientTable from '../Components/IngredientTable.vue';
//import Instructions from '../Components/Instructions.vue';
//import uuid from 'uuid';
//import vue2Dropzone from 'vue2-dropzone'
import { authHeader } from "../../_helpers";
import axios from "axios";

 const apiClient = axios.create({
   baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/ingredients/`,
  withCredentials: false,
  headers: authHeader(),
});

export default {
  name: "EditIngredient",
  components: {
    apiClient
  },
  data() {
    return {
      model: {
        id: '',
        description: '',
        isActive: true,
        isDeleted: false,
        isVisible: true,
      },
      validated: false,
    };
  },
  computed: {
    ingredient() {
      return this.$store.state.ingredients.current;
    },
    allUnits() {
      return Object.values(this.$store.state.units.all);
    },
  },
  methods: {
    firstFormSubmit() {
      const sendData = this.model;
      const { dispatch } = this.$store;
      if (sendData.description) {
        try {
          this.updateIngredient(sendData)
            .then((response) => {
              this.$notify({
                verticalAlign: "top",
                horizontalAlign: "right",
                type: "success",
                message: "Ingredient updated",
              });
              this.$router.push(`/ingredients`)
            })
            .catch((error) => {
              console.log("Something went wrong: ", error);
            });
        } catch (error) {
          console.log("Error: ingredient edit", error);
        }
      }
    },
    getIngredient(id) {
      return apiClient.get(`${id}`);
    },
    async updateIngredient(ingredient) {
      const { dispatch } = this.$store;
        await dispatch(`ingredients/editIngredient`, ingredient)
        .then(response => {
          dispatch("ingredients/getIngredients",{
          "query": '', 
          "page": 1, 
          "pageSize": 25, 
          "filter": "I",
          "dataTypes": ['whipstir']
          });
          return response.data
        })
        .catch(error => {
          return false
        });
    }
  },
  created() {
    this.model.id = this.$route.params.id;
    this.getIngredient(this.model.id)
      .then((response) => {
        this.model = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
<style>
.shortcut-item.add-collection {
  text-align: left;
  margin-bottom: 30px;
}
</style>
